define('app-Slider/settings',[],function () {
    return {
        container: '.bxslider',
        titles: '.heroName',
        descriptions: '.heroDescription'
    };
});
